const EventStatus = {
  FAILED: 'FAILED',
  PAUSED: 'PAUSED',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
};

Object.freeze(EventStatus);
export default EventStatus;
